import { render, staticRenderFns } from "./eb-tag.vue?vue&type=template&id=2878d10c&scoped=true&"
import script from "./eb-tag.vue?vue&type=script&lang=js&"
export * from "./eb-tag.vue?vue&type=script&lang=js&"
import style0 from "./eb-tag.vue?vue&type=style&index=0&id=2878d10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878d10c",
  null
  
)

export default component.exports